

























































































































































































































































import { Vue, Component } from 'vue-property-decorator'
import { IDownedRes } from '@/api/files/files-updown/res'
import { getAndroidDownedList, getAndroidAppChannelList, recoverUpAppAndroid } from '@/api/files/files-updown/filesUpdown'

import { Form } from 'element-ui'
import { resetObjValue2NoneString } from '@/utils/tool'
import { getChaos, getCookie, getImgURLOfBase64 } from '@/utils/fix'
import { getAndroidSource, getDownStatus, getSearchCategory } from '@/api/common'
import { mixins } from 'vue-class-component'
import DateOption from '@/mixins/dateOption'
@Component({
  name: 'FilesUpdownAndroidDowned'
})
export default class extends mixins(DateOption) {
  // data
  private params = {
    id: '',
    name: '',
    fileBundleid: '',
    offlineStatus: '',
    source: '',
    updateDateStart: '',
    updateDateEnd: '',
    page: 1,
    pageCount: 20
  }
  private upParams = {
    id: '',
    channel: [],
    startDate: '',
    endDate: ''
  }
  // template data
  private sourceList: Array<ISelectItem> = []
  private downStatusList: ISelectItem[] = []
  private channelList: Array<{id: string, name: string, disabled?: boolean}> = []

  private upFormVisible: boolean = false
  private tableData: IDownedRes[] = []
  private selectedData: IDownedRes[] = []
  private totalCount: number = 0
  private dateArray: string[] = ['', '']

  routeQuery: IQuery = { id: 0, platform: 'android' }
  private rules: any = {
    id: [{ required: true, message: '请输入ID', trigger: 'blur' }],
    channel: [{ required: true, message: '选择语言渠道', trigger: 'change' }],
    startDate: [
      {
        required: true,
        message: '请选择开始时间',
        trigger: 'blur'
      }
    ],
    type: [{ required: true, message: '选择类型', trigger: 'change' }],
    reason: [{ required: true, message: '选择原因', trigger: 'change' }],
    distributeArea: [{ type: 'array', required: true, message: '请至少选择一个地区', trigger: 'change' }]
  }
  tableLoading = false
  openWindow: any
  tableHeight: number = 500
  // lifecycle
  created() {
    this.getTableData()
    this.getAndroidSource()
    this.getDownStatusList()
    this.getAllChannel()
    this.$nextTick(() => {
      this.setTableHeight()
      window.addEventListener('resize', this.setTableHeight)
    })
  }
  beforeDestroy() {
    window.removeEventListener('resize', this.setTableHeight)
  }
  // methods
  async getTableData() {
    this.tableLoading = true
    let res = await getAndroidDownedList(this.params)
    let dataList = res.data.dataList || []
    let buildEnv = process.env.VUE_APP_ENV || ''
    if (buildEnv !== 'env') {
      this.tableData = dataList
      this.tableLoading = false
      this.totalCount = res.data.pageInfo.totalCount
      return false
    }
    this.tableData = []
    await getChaos()
    let header = {
      abc: getCookie('abc')
    }
    this.tableLoading = false
    const cover: string = require('@/assets/images/loading.svg')
    dataList.forEach((item: any) => {
      let el = { ...item }
      el.icon = cover
      this.tableData.push(el)
    })
    this.totalCount = res.data.pageInfo.totalCount
    for (let i = 0; i < dataList.length; i++) {
      getImgURLOfBase64(dataList[i].icon, header).then(res => {
        this.tableData[i]['icon'] = res as string
      })
    }
    this.tableLoading = false
    this.totalCount = res.data.pageInfo.totalCount
  }
  async getAndroidSource() {
    let res = await getAndroidSource()
    this.sourceList = res.data.dataList
  }
  async getDownStatusList() {
    let res = await getDownStatus()
    this.downStatusList = res.data
  }
  async getAndroidAppChannelList(id: number) {
    let res = await getAndroidAppChannelList({ id })
    return res.data.dataList
  }
  async getAllChannel() {
    let res: any = await getSearchCategory({
      isIos: false
    })
    let list = res.data
    this.channelList = list.map((item: any) => {
      return {
        id: item.id,
        name: item.name,
        disabled: false
      }
    })
  }
  handleInput(val: string, attr: string) {
    (this.params as any)[attr] = val.replace(/[^0-9]/g, '')
  }
  async recoverUpAppAndroid() {
    let res: any = await recoverUpAppAndroid({
      ids: this.upParams.id,
      channel: this.upParams.channel.join(','),
      startDate: this.upParams.startDate,
      endDate: this.upParams.endDate
    })
    if (res.status.code === 0) {
      this['$message'].success('提交成功!')
      this.cancelUpForm()
      this.getTableData()
    } else {
      this['$message'].error('提交失败!')
    }
  }
  setTableHeight() {
    const filter: any = this.$refs.filter
    const filterDom: any = filter.$el
    this.tableHeight = document.body.clientHeight - 260 - filterDom.clientHeight
  }
  handleDateChange(date: string[]) {
    this.params.updateDateStart = date && date[0]
    this.params.updateDateEnd = date && date[1]
  }
  handleSearch() {
    if (this.tableLoading) { return false }
    let params:any = { ...this.params }
    for (let i in params) {
      if (typeof params[i] === 'string') {
        params[i] = params[i].trim()
      }
    }
    this.params = params
    this.params.page = 1
    this.getTableData()
  }
  handleReset() {
    resetObjValue2NoneString(this.params, ['page', 'pageCount'])
    this.dateArray = ['', '']
    this.params.page = 1
    this.getTableData()
  }
  handleSelectionChange(list: IDownedRes[]) {
    this.selectedData = list
  }
  handleSelectReverse() {
    this.selectedData = []
    let tempList: number[] = []
    let tempSelectList: number[] = []
    let indexList: number[] = []
    tempList = this.tableData.map(item => item.id)
    tempSelectList = this.selectedData.map(item => item.id)
    indexList = tempList.filter(item => !tempSelectList.includes(item))
    this.tableData.forEach(item => {
      if (indexList.includes(item.id)) this.selectedData.push(item)
    })

    // this.selectedData = this.tableData.filter(item => indexList.includes(item.id))
    if (this.selectedData.length) {
      this.selectedData.forEach(row => {
        (this.$refs['multiTable'] as any).toggleRowSelection(row)
      })
    } else {
      (this.$refs['multiTable'] as any).clearSelection()
    }
  }
  handlePutAll() {
    let canRecover = this.selectedData.some(item => item.offlineStatusId === 1 || item.offlineStatusId === 0)
    if (canRecover) {
      this['$message'].warning('请选择正确状态的应用...')
      return
    }
    this.upFormVisible = true
    let t: number[] = []
    this.selectedData.forEach(item => {
      t.push(item.id)
    })
    this.upParams.id = t.join(',')
  }
  resetChannelList() {
    this.channelList.forEach(item => {
      item.disabled = false
    })
  }
  handleFormClose() {
    this.resetChannelList()
  }
  selectAll(flag:boolean) {
    if (flag) {
      this.upParams.channel = this.channelList.map((item: any) => item.id) as []
    }
  }
  async putApp(item: IDownedRes) {
    console.log(item.id)
    this.upParams.channel = []
    this.upFormVisible = true
    let hasSelectedChannelList = await this.getAndroidAppChannelList(item.id)
    let { channelList } = hasSelectedChannelList
    this.channelList.forEach(item => {
      if (channelList.includes(item.id)) {
        item.disabled = true
      }
    })
    this.upParams.id = (item.id).toString()
  }
  goToDetail(item: IDownedRes) {
    this.routeQuery.id = item.id
    this.openWindow({
      name: 'AppDetail',
      query: this.routeQuery
    })
  }
  cancelUpForm() {
    (this.$refs['upParams'] as Form).resetFields()
    this.upParams.endDate = ''
    this.upFormVisible = false
  }
  confirmUpForm() {
    (this.$refs['upParams'] as Form).validate(valid => {
      if (valid) {
        this.recoverUpAppAndroid()
      } else {
        this['$message'].error('请填写缺失参数!')
        return false
      }
    })
  }
  confirmSrc(src: string) {
    return src.replace('.com//', '.com/')
  }
  // computed
  get showMultiSelect() {
    return this.selectedData.length > 1
  }
  get selectCount() {
    return this.selectedData.length
  }
}
